import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {ViewportScroller} from "@angular/common";

@Component({
  selector: 'btx-read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss'],
  animations: [
    trigger('indicatorRotate', [
        state('collapsed', style({transform: 'rotate(0deg)'})),
        state('expanded', style({transform: 'rotate(180deg)'})),
        transition('expanded <=> collapsed',
          animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
        ),
      ]
    )
  ],
  standalone: false
})
export class ReadMoreComponent implements OnInit, OnChanges {


  @Input() text!: string | any;

  @Input() maxLength: number = 500;

  @Input() anchor!: string | any;

  currentText?: string;
  hideToggle: boolean = false;
  public isCollapsed: boolean = true;

  constructor(private viewportScroller: ViewportScroller) {
  }

  ngOnInit(): void {
  }

  toggleView() {
    if (this.anchor) {
      this.viewportScroller.scrollToAnchor(this.anchor);
      return;
    }
    //
    this.isCollapsed = !this.isCollapsed;
    this.determineView();
  }

  /**
   * Görünümü belirle
   */
  determineView() {
    let textLength = this.text.length;
    if (textLength <= this.maxLength) {
      this.currentText = this.text;
      this.isCollapsed = false;
      this.hideToggle = true;
      return;
    }

    if (this.isCollapsed) {
      this.currentText = this.text.substring(0, this.maxLength);
    } else {
      this.currentText = this.text;
    }
  }

  /**
   *TODO: Dİl dosyası key verilecek
   */
  get toggleText() {
    return this.isCollapsed ? 'shared.labels.showMore' : 'shared.labels.showLess';
  }


  ngOnChanges(changes: SimpleChanges): void {
     this.determineView();
  }

}
